var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordEyeOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5868 20.5867C22.3903 20.7698 22.2326 20.9906 22.1233 21.2359C22.014 21.4812 21.9552 21.7461 21.9505 22.0146C21.9458 22.2832 21.9952 22.5499 22.0958 22.7989C22.1963 23.048 22.3461 23.2742 22.536 23.4641C22.7259 23.654 22.9521 23.8037 23.2012 23.9043C23.4502 24.0049 23.7169 24.0543 23.9855 24.0496C24.254 24.0448 24.5189 23.9861 24.7642 23.8768C25.0095 23.7674 25.2303 23.6098 25.4134 23.4133",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1533 17.3867C23.4342 17.3517 23.7169 17.3339 24 17.3334C28.6667 17.3334 30.6667 22 30.6667 22C30.3686 22.6381 29.9948 23.238 29.5533 23.7867",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4068 18.4066C19.081 19.3097 18.0201 20.5501 17.3335 21.9999C17.3335 21.9999 19.3335 26.6666 24.0002 26.6666C25.2774 26.67 26.5274 26.2967 27.5935 25.5933",
    stroke: "#6B7280",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEyeOpen);
export default __webpack_public_path__ + "static/media/PasswordEyeOpen.71cd6fba2b52e38ddc32ddeb580ee677.svg";
export { ForwardRef as ReactComponent };